import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Table, Button } from 'react-bootstrap';
import TableTemplate from '../../components/TableTemplate';
import ModuleHeader from '../../components/ModuleHeader';
import { EMPTY_COUNT, ERROR_BEHIND_DATA, ERROR_AFTER_DEADLINE, EMPTY_STRING, SUCCESS, MAX_10_DIGITS, KANA_NO, KANA_YES, ERROR_INVALID_ORDER_CONTROL_PATTERN } from '../../../utils/constants';
import { orderItemsOperations, orderItemsSelectors } from "./state";
import { formatCurrency, isWholeNumber, formatPlaceValue } from '../../../utils/common';
import ErrorAlert from '../../components/ErrorAlert';
import SuccessAlert from '../../components/SuccessAlert';
import Confirmation from '../../components/Confirmation';
import { isNullOrEmpty } from '../../../utils/common';
import { ORDER_SHOPS } from '../BPOrder/routes';
import { RELOAD_MASTER_UPDATED, ERROR_ORDER_ITEMS_UPDATE } from '../../../utils/messages';
import moment from 'moment';

class OrderItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalOrder: EMPTY_COUNT,
            totalPrice: EMPTY_COUNT,
            success: [],
            styles: [],
            error: [],
            list: [],
            invalidMessage: true,
            reload: false,
            disableSubmit: true,
            ...this.props.location.state && this.props.location.state.proposal
        };
    }

    componentWillMount() {
        this.props.fetchDefault(this.setFetchParams())
            .then(() => {
                this.calculateTotal(this.props.tableList)
            });
    }

    handlePriceChange = (e) => {
        if (MAX_10_DIGITS >= e.target.value  || EMPTY_STRING === e.target.value) {
            let newAmt = Number(e.target.value);
            let newStateList = this.state.list
            let newItem = newStateList[e.target.id]

            if(EMPTY_STRING === e.target.value || (MAX_10_DIGITS >= newAmt && isWholeNumber(newAmt))){
                newItem.orderedProducts = (EMPTY_STRING === e.target.value) ? EMPTY_STRING : newAmt;

                if ( EMPTY_COUNT <= newAmt) {               
                    newItem.totalPrice = newAmt * newItem.proposalPrice;      
                }

                this.calculateTotal(newStateList)
              
            }
        }
        if (EMPTY_STRING === e.target.value) {
            this.setState({disableSubmit: true});
        } else if (MAX_10_DIGITS >= e.target.value){
            this.setState({disableSubmit: false});
        }
    }

    calculateTotal = (list) => {
        let totalOrder = EMPTY_COUNT
        let totalPrice = EMPTY_COUNT
        list && list.map(record => {
            record.totalAmount = Number(record.totalPrice)
            totalOrder += Number(record.orderedProducts)
            totalPrice +=  Number(record.totalPrice)
            return EMPTY_STRING;
        })
        this.setState({
            totalOrder: totalOrder,
            totalPrice: totalPrice,
            list: list
        })
    }

    editOrder = (invalidMessage) => {
        this.setState({ error: [], success: [] });
        let itemsList = this.state.list.filter(order => (order.orderedProducts || order.orderDate || !isNullOrEmpty(order.orderedProducts)));
        let errorList = orderItemsSelectors.validate(itemsList);
        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList });
        } else {    
            this.props.editOrders(itemsList, this.props.loginId, moment(this.state.deliveryDttm), invalidMessage)
                .then((result) => {
                    if(SUCCESS === result.status){
                        this.props.fetchDefault(this.setFetchParams())
                        .then(() => {
                            this.calculateTotal(this.props.tableList)
                            this.setState({ success: [result.message] })
                        })
                    }else{
                        if (ERROR_BEHIND_DATA === result.data) {
                            this.setState({ reload: true});
                        }else if(ERROR_AFTER_DEADLINE === result.data){
                            this.setState({ modalMessage:result.message,  openModal: true, promptDeadline:true, promptOrderControlPattern:false })
                        }else if(ERROR_INVALID_ORDER_CONTROL_PATTERN === result.data){
                            this.setState({ modalMessage:result.message,  openModal: true, promptOrderControlPattern:true, promptDeadline:false })
                        }else{
                            this.setState({ error: [result.message] });
                        }
                    }
                }).catch(()=> this.setState({ error: [ERROR_ORDER_ITEMS_UPDATE] }))
        }
        this.setState({ openModal: false })
    }

    setFetchParams = () => {
        return {
            proposalId: this.state.proposalId,
            orderDttm: this.state.deliveryDttm,
            deliveryDttm: this.state.deliveryDttm,
            shopMainNumber: this.state.shopMain,
            shopBranchNumber: this.state.shopBranch,
            isMobile: false
        }
    }

    returnToShops = (e) => {
        this.props.history.push({
            pathname: ORDER_SHOPS,
            state: this.props.location.state
        })
    }

    titleLabels() {
        return (
            <span className="title-action2">
                <span className="title-text">
                    <span className="extra-text2"><b>取引先名</b></span>
                    <span className="extra-text2"><b>発注締日時</b></span>
                </span>
                <span className="title-text"> 
                    <span className="extra-text3">{this.state.shopName}</span>
                    <span className="extra-text3">{this.state.orderDateDisplay}</span>
                </span>
            </span>
        )
    }

    displayTotal = () => {
        let startIndex = 3
        let totalId = "total-items"
        orderItemsSelectors.setTotalTableStyle(totalId, startIndex)
        return (
            <div id={totalId}>
                <br />
                <Table >
                    <tbody>
                        <tr>
                            <td id={totalId + "-" + (startIndex++)} className="table-header">計</td>
                            <td id={totalId + "-" + (startIndex++)} className="text-right">{formatPlaceValue(this.state.totalOrder)}</td>
                            <td id={totalId + "-" + (startIndex)} className="text-right">{formatCurrency(this.state.totalPrice) + "円"}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )
    }


    prompt = () => {
        return this.state.openModal &&
             <Confirmation
             message={this.state.modalMessage}
             showConfirmation={this.state.openModal}
             buttons={[
                 { label: KANA_YES, action: ()=> this.editOrder((this.state.promptDeadline && ERROR_AFTER_DEADLINE) || (this.state.promptOrderControlPattern && ERROR_INVALID_ORDER_CONTROL_PATTERN)) },
                 { label: KANA_NO, action: () => this.setState({ openModal: false }) }
             ]}
         />
    }

    editButton = () => {
        return (
            <div>
                {this.state.list && EMPTY_COUNT < this.state.list.length &&
                    <Button
                        className="button-filter list-button"
                        onClick={() => this.setState({ modalMessage:"注文しますか？",  openModal: true, promptDeadline:false, promptOrderControlPattern:false }) }
                        disabled={this.state.disableSubmit}
                    >
                        登録
                    </Button>
                }
                <Button
                    className="button-filter list-button"
                    onClick={this.returnToShops}
                >
                    戻る
                </Button>
            </div>
        )
    }

    showReload = () => {
        return this.state.reload && (
            <Confirmation
                message={RELOAD_MASTER_UPDATED}
                showConfirmation={true}
                buttons={[
                    { label: "OK", action: ()=>window.location.reload() },
                ]}
            />
        );
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    {this.showReload()}
                    <ModuleHeader
                        title={"受注状況商品一覧"}
                        titleAction={this.titleLabels()} />

                    <ErrorAlert errors={this.state.error} />
                    <SuccessAlert success={this.state.success} />

                    <TableTemplate
                        {...this.props}
                        tableList={this.state.list}
                        handlePriceChange={this.handlePriceChange}
                    />
                    {this.displayTotal()}
                    <br />
                    {this.editButton()}
                    {this.prompt()}
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loginId: state.auth.credentials.user_cd,
        tableHeader: state.orderItems.tableHeader,
        tableList: state.orderItems.list,
        tableColumns: state.orderItems.tableColumns,
    }
};

const mapDispatchToProps = {
    fetchDefault: orderItemsOperations.fetchDefault,
    fetchDeadline: orderItemsOperations.fetchDeadline,
    editOrders: orderItemsOperations.updateOrders,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderItems);